import React, { createContext, useState, useEffect } from 'react';

export const PopupContext = createContext();

export const PopupProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [position, setPosition] = useState({ x: 100, y: 100 });
  const [popupData, setPopupData] = useState({
  });

  // Load state from memory on mount
  useEffect(() => {
    const savedState = window.popupState || {
      isOpen: false,
      isMinimized: false,
      position: { x: 100, y: 100 },
      popupData: {
        title: 'Floating Popup',
        content: '',
        notes: ''
      }
    };
    
    setIsOpen(savedState.isOpen);
    setIsMinimized(savedState.isMinimized);
    setPosition(savedState.position);
    setPopupData(savedState.popupData);
  }, []);

  // Save state to memory whenever it changes
  useEffect(() => {
    window.popupState = {
      isOpen,
      isMinimized,
      position,
      popupData
    };
  }, [isOpen, isMinimized, position, popupData]);

  const openPopup = () => setIsOpen(true);
  const closePopup = () => setIsOpen(false);
  const toggleMinimize = () => setIsMinimized(!isMinimized);


  
  
  const updatePopupData = (newData) => {
    setPopupData(prev => ({ ...prev, ...newData }));
  };

  return (
    <PopupContext.Provider value={{
      isOpen,
      isMinimized,
      position,
      popupData,
      openPopup,
      closePopup,
      toggleMinimize,
      setPosition,
      updatePopupData
    }}>
      {children}
    </PopupContext.Provider>
  );
};